import { IntlShape } from 'react-intl';

const translateSeason = (seasonCode: string, intl: IntlShape): string => {
  let label: string;

  const match = (seasonCode ?? '').match(/^(SS|FW)_(\d{4})$/);
  if (match) {
    const prefix = match[1];
    const year = match[2];

    const translatedPrefix = intl.formatMessage({
      id: `product.seasons.${prefix}`,
      defaultMessage: prefix,
    });
    label = `${translatedPrefix} ${year}`;
  } else {
    label = intl.formatMessage({
      id: `product.seasons.${seasonCode}`,
      defaultMessage: seasonCode,
    });
  }

  return label;
};

const translateOnlyFallback = (attribute: string, intl: IntlShape): string => {
  return attribute === 'unknown' || attribute === 'unavailable'
    ? intl.formatMessage({ id: `model.attribute.fallback.${attribute}`, defaultMessage: attribute })
    : attribute;
};

export { translateSeason, translateOnlyFallback };
